import React from 'react'
import { Activity } from '../../api/schemas/schema'
import { tokens } from '@fluentui/react-components'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
dayjs.extend(isSameOrBefore)

type ActivityStatusBadgeProps = {
   item: Activity
}
export const ActivityStatusBadge = ({ item }: ActivityStatusBadgeProps) => {
   const todaysDate = dayjs().startOf('day')
   const startDate = dayjs.utc(item.startDate).local().startOf('day')
   const endDate = item.endDate ? dayjs.utc(item.endDate).local().startOf('day') : null

   const getBgColor = () => {
      if (startDate.isAfter(todaysDate)) {
         return '#566577'
      } else if (endDate && startDate.isSameOrBefore(todaysDate) && endDate.isSameOrAfter(todaysDate)) {
         return '#13A10E'
      } else if (startDate.isSameOrBefore(todaysDate) && item.endDate === null) {
         return '#FFB900'
      } else if (startDate.isSameOrBefore(todaysDate) && endDate !== null && endDate.isBefore(todaysDate)) {
         return '#D13438'
      }
   }
   return <div style={{ backgroundColor: getBgColor(), width: '4px', minHeight: '30px', borderRadius: tokens.borderRadiusXLarge }}></div>
}
